import { StarIcon } from '@heroicons/react/20/solid';
import PropTypes from 'prop-types';
import { classNames } from '../../utils/common';

const QuoteMarkIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className="h-5 w-5">
    <path d="M7.17 6 4 11v5h5v-5H6.83L10 6H7.17zm9 0-3.17 5v5h5v-5h-2.17L19 6h-2.83z" />
  </svg>
);

function TestimonialItem({ item }) {
  const hasLongBody = item.body?.length > 150;
  const reviewSubtitle = item.title || item.subtitle || item.author?.handle;
  const baseBodyClass = 'block text-sm leading-relaxed text-gray-600';
  const bodyWrapperClass = classNames('mt-4 flex-1', hasLongBody ? 'overflow-hidden' : '');
  const bodyScrollClass = classNames(baseBodyClass, hasLongBody ? 'max-h-16 overflow-y-auto pr-2' : '');

  return (
    <div className="inline-block w-full px-3 sm:px-4">
      <article className="relative flex h-52 flex-col rounded-xl border border-gray-100 bg-white p-6 text-left shadow-[0_15px_45px_rgba(15,23,42,0.08)]">
        <div className="absolute right-6 top-12 flex h-10 w-10 items-center justify-center rounded-full bg-teal-50 text-teal-500">
          <QuoteMarkIcon />
        </div>

        <div className="flex shrink-0 items-start gap-4">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-teal-500/15">
            <img
              className="h-14 w-14 rounded-full object-cover ring-2 ring-white"
              src={item.author.imageUrl}
              alt={item.author.name}
            />
          </div>

          <div className="flex-1">
            <div className="text-base font-semibold text-gray-900">{item.author.name}</div>
            {reviewSubtitle && (
              <div className="mt-0.5 text-sm font-medium text-gray-500">{reviewSubtitle}</div>
            )}

            <div className="mt-2 flex gap-1">
              {[0, 1, 2, 3, 4].map((rating) => (
                <StarIcon
                  key={rating}
                  className={classNames(
                    item.rating > rating ? 'text-yellow-400' : 'text-gray-200',
                    'h-4 w-4 flex-shrink-0',
                  )}
                  aria-hidden="true"
                />
              ))}
            </div>
          </div>
        </div>

        <div className={bodyWrapperClass}>
          <p className={bodyScrollClass}>{item.body}</p>
        </div>
      </article>
    </div>
  );
}

TestimonialItem.propTypes = {
  item: PropTypes.object.isRequired,
};

export default TestimonialItem;
